/* Cart drawer — populates the "Recently viewed" tab from localStorage each
   time the drawer opens (survives cart.js re-renders, which replace the DOM). */
(function () {
  'use strict';
  var KEY = 'lumen:recently-viewed';

  function money(v) { return typeof v === 'string' ? v : ''; }

  function render(mount, emptyEl) {
    var items = [];
    try { items = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { items = []; }
    if (!Array.isArray(items)) items = [];

    // Only same-origin, path-only URLs (stored data is inert until used here).
    items = items.filter(function (it) {
      return it && typeof it.url === 'string' && it.url.charAt(0) === '/' && it.title;
    }).slice(0, 8);

    mount.textContent = '';
    if (!items.length) {
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;

    var frag = document.createDocumentFragment();
    items.forEach(function (it) {
      var a = document.createElement('a');
      a.className = 'cart-drawer__recent-item';
      a.href = it.url;
      a.setAttribute('data-dialog-close', '');

      var media = document.createElement('span');
      media.className = 'cart-drawer__recent-media';
      if (it.image && typeof it.image === 'string' && it.image.indexOf('//') !== -1) {
        var img = document.createElement('img');
        img.src = it.image;
        img.alt = '';
        img.loading = 'lazy';
        media.appendChild(img);
      }
      a.appendChild(media);

      var body = document.createElement('span');
      body.className = 'cart-drawer__recent-body';
      var title = document.createElement('span');
      title.className = 'cart-drawer__recent-title';
      title.textContent = it.title;
      body.appendChild(title);
      if (it.price) {
        var price = document.createElement('span');
        price.className = 'cart-drawer__recent-price';
        price.textContent = money(it.price);
        body.appendChild(price);
      }
      a.appendChild(body);
      frag.appendChild(a);
    });
    mount.appendChild(frag);
  }

  function hydrate(root) {
    var host = root || document;
    var mount = host.querySelector('[data-recently-viewed-mount]');
    if (!mount) return;
    var emptyEl = host.querySelector('[data-recently-viewed-empty]');
    render(mount, emptyEl);
  }

  // Populate whenever the cart drawer opens (event bubbles from lumen-drawer).
  document.addEventListener('dialog:open', function (e) {
    var host = e.target;
    if (host && host.id === 'CartDrawer') { hydrate(host); startTimer(false); renderSaved(); checkGiftUnlock(); }
  });
  // First load, in case the drawer is already in the DOM.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hydrate(document.getElementById('CartDrawer')); });
  } else {
    hydrate(document.getElementById('CartDrawer'));
  }

  /* ---- Cart urgency reservation timer ----------------------------------- */
  var TIMER_KEY = 'lumen:cart-timer';
  var timerInterval = null;

  function timerDeadline(minutes, reset) {
    var now = Date.now();
    var stored = parseInt(sessionStorage.getItem(TIMER_KEY), 10);
    if (reset || !stored || stored < now) {
      stored = now + minutes * 60000;
      try { sessionStorage.setItem(TIMER_KEY, String(stored)); } catch (e) {}
    }
    return stored;
  }

  function startTimer(reset) {
    var el = document.querySelector('#CartDrawer [data-cart-timer]');
    if (!el) { if (timerInterval) { clearInterval(timerInterval); timerInterval = null; } return; }
    var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 10;
    var clock = el.querySelector('[data-cart-timer-clock]');
    var deadline = timerDeadline(minutes, reset);
    el.hidden = false;
    function tick() {
      var remaining = Math.max(0, deadline - Date.now());
      var mins = Math.floor(remaining / 60000);
      var secs = Math.floor((remaining % 60000) / 1000);
      if (clock) clock.textContent = mins + ':' + (secs < 10 ? '0' : '') + secs;
      if (remaining <= 0 && timerInterval) { clearInterval(timerInterval); timerInterval = null; }
    }
    if (timerInterval) clearInterval(timerInterval);
    tick();
    timerInterval = setInterval(tick, 1000);
  }

  /* ---- Discount code field (delegated; survives re-renders) -------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-discount]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('[data-cart-discount-input]');
    var footer = form.parentNode;
    var msg = footer && footer.querySelector('[data-cart-discount-msg]');
    var code = input && input.value.trim();
    if (!code) return;
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    fetch('/discount/' + encodeURIComponent(code), { method: 'GET' })
      .then(function () { return (window.theme && theme.cart && theme.cart.refresh) ? theme.cart.refresh() : null; })
      .then(function () {
        var fresh = document.querySelector('#CartDrawer [data-cart-discount-msg]') || msg;
        if (fresh) { fresh.hidden = false; fresh.textContent = 'Code applied — discount shows at checkout.'; }
      })
      .catch(function () { if (msg) { msg.hidden = false; msg.textContent = 'Could not apply that code.'; } })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  // Reset the reservation timer + re-render saved list whenever the cart changes.
  document.addEventListener('cart:updated', function () { startTimer(true); renderSaved(); checkGiftUnlock(); });

  /* ---- Free-gift unlock celebration (fires once per unlock) -------------- */
  var giftUnlockedBefore = false;
  function checkGiftUnlock() {
    var bar = document.querySelector('#CartDrawer [data-gift-unlocked]');
    var unlocked = !!bar;
    if (unlocked && !giftUnlockedBefore) {
      bar.classList.add('is-celebrating');
      setTimeout(function () { if (bar) bar.classList.remove('is-celebrating'); }, 900);
    }
    giftUnlockedBefore = unlocked;
  }

  /* ---- Save for later (localStorage) ------------------------------------ */
  var SAVED_KEY = 'lumen:saved-for-later';
  function getSaved() {
    try { var a = JSON.parse(localStorage.getItem(SAVED_KEY) || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  function setSaved(a) { try { localStorage.setItem(SAVED_KEY, JSON.stringify(a.slice(0, 20))); } catch (e) {} }

  function renderSaved() {
    var wrap = document.querySelector('#CartDrawer [data-saved-for-later]');
    var mount = document.querySelector('#CartDrawer [data-saved-for-later-mount]');
    if (!wrap || !mount) return;
    var items = getSaved();
    mount.textContent = '';
    if (!items.length) { wrap.hidden = true; return; }
    wrap.hidden = false;
    var frag = document.createDocumentFragment();
    items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'cart-drawer__saved-item';

      var media = document.createElement('a');
      media.className = 'cart-drawer__saved-media';
      media.href = (typeof it.url === 'string' && it.url.charAt(0) === '/') ? it.url : '#';
      media.setAttribute('data-dialog-close', '');
      if (it.image && typeof it.image === 'string' && it.image.indexOf('//') !== -1) {
        var img = document.createElement('img'); img.src = it.image; img.alt = ''; img.loading = 'lazy';
        media.appendChild(img);
      }
      row.appendChild(media);

      var body = document.createElement('div'); body.className = 'cart-drawer__saved-body';
      var t = document.createElement('span'); t.className = 'cart-drawer__saved-title'; t.textContent = it.title || '';
      body.appendChild(t);
      if (it.price) { var p = document.createElement('span'); p.className = 'cart-drawer__saved-price'; p.textContent = it.price; body.appendChild(p); }
      row.appendChild(body);

      var actions = document.createElement('div'); actions.className = 'cart-drawer__saved-actions';
      var move = document.createElement('button');
      move.type = 'button'; move.className = 'btn btn--secondary btn--sm'; move.textContent = 'Move to cart';
      move.setAttribute('data-move-to-cart', ''); move.setAttribute('data-variant-id', it.variantId); move.setAttribute('data-qty', it.qty || 1);
      actions.appendChild(move);
      var rm = document.createElement('button');
      rm.type = 'button'; rm.className = 'cart-drawer__saved-remove'; rm.setAttribute('aria-label', 'Remove');
      rm.setAttribute('data-remove-saved', ''); rm.setAttribute('data-variant-id', it.variantId); rm.textContent = '×';
      actions.appendChild(rm);
      row.appendChild(actions);
      frag.appendChild(row);
    });
    mount.appendChild(frag);
  }

  document.addEventListener('click', function (e) {
    var save = e.target.closest('[data-save-for-later]');
    if (save) {
      e.preventDefault();
      var item = {
        variantId: save.getAttribute('data-variant-id'),
        qty: parseInt(save.getAttribute('data-qty'), 10) || 1,
        title: save.getAttribute('data-title'),
        image: save.getAttribute('data-image'),
        url: save.getAttribute('data-url'),
        price: save.getAttribute('data-price')
      };
      var saved = getSaved().filter(function (s) { return s.variantId !== item.variantId; });
      saved.unshift(item);
      setSaved(saved);
      if (window.theme && theme.cart) theme.cart.change(save.getAttribute('data-line-key'), 0);
      return;
    }
    var move = e.target.closest('[data-move-to-cart]');
    if (move) {
      e.preventDefault();
      var vid = move.getAttribute('data-variant-id');
      var qty = parseInt(move.getAttribute('data-qty'), 10) || 1;
      setSaved(getSaved().filter(function (s) { return s.variantId !== vid; }));
      if (window.theme && theme.cart) theme.cart.add({ id: parseInt(vid, 10), quantity: qty }, { openDrawer: false });
      else renderSaved();
      return;
    }
    var rms = e.target.closest('[data-remove-saved]');
    if (rms) {
      e.preventDefault();
      var v = rms.getAttribute('data-variant-id');
      setSaved(getSaved().filter(function (s) { return s.variantId !== v; }));
      renderSaved();
    }
  });

  /* ---- Policies checkbox gates the checkout button ---------------------- */
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-cart-policies-agree]');
    if (!cb) return;
    var btn = document.querySelector('#CartDrawer [data-checkout-btn]');
    if (!btn) return;
    btn.classList.toggle('is-disabled', !cb.checked);
    if (cb.checked) btn.removeAttribute('aria-disabled');
    else btn.setAttribute('aria-disabled', 'true');
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-checkout-btn]');
    if (!btn || !btn.classList.contains('is-disabled')) return;
    e.preventDefault();
    var cb = document.querySelector('#CartDrawer [data-cart-policies-agree]');
    if (cb) {
      var wrap = cb.closest('.cart-drawer__policies');
      if (wrap) { wrap.classList.remove('shake'); void wrap.offsetWidth; wrap.classList.add('shake'); }
      cb.focus();
    }
  });

  /* ---- Checkbox-style cart upsells (tick to add; never auto-added) ------- */
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-upsell-add]');
    if (!cb || !cb.checked) return;
    var vid = parseInt(cb.getAttribute('data-variant-id'), 10);
    if (!vid) return;
    cb.disabled = true;
    if (window.theme && theme.cart && theme.cart.add) {
      theme.cart.add({ id: vid, quantity: 1 }, { openDrawer: false });
    }
  });

  /* ---- Cart add-on toggle (shipping protection, gift wrap, …) ------------ */
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-cart-addon]');
    if (!cb) return;
    var vid = parseInt(cb.getAttribute('data-variant-id'), 10);
    if (!vid) return;
    cb.disabled = true;
    if (cb.checked) {
      if (window.theme && theme.cart && theme.cart.add) {
        theme.cart.add({ id: vid, quantity: 1, properties: { _addon: 'true' } }, { openDrawer: false });
      }
    } else {
      var key = cb.getAttribute('data-addon-key');
      if (key && window.theme && theme.cart && theme.cart.change) theme.cart.change(key, 0);
    }
  });
})();
